import { useLocation } from "react-router-dom";

export const useClassNameByLocation = (name?) => {
  const location = useLocation();
  const { pathname } = location;

  if (pathname.includes("followup")) {
    if (name === "readOnlyModeParent") {
      return "readOnlyModeParent";
    }
    return "readOnlyMode";
  }
  return null;
};
